import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class TwoMinSuspension extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"2 MINUTES"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "2 MINUTES",
            player: event.detail?.player,
            reason: event.detail?.reason,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    get reason() {
        return this.detail.reason;
    }
    set reason(value) {
        this.detail.reason = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "reason"].includes(key)){
            let commentaire = "2 minutes"

            const team = getTeam(this.team, match)
            const cardPlayer = getPlayer(this.player, match, team)

            if(this.player){
                if(cardPlayer){
                    commentaire += ' pour '+ cardPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(this.reason){
                switch(this.reason){
                    case 'repeatedFouls':
                        commentaire+='Raison : Fautes répétées.'
                    break
                    case 'unsportingBehavior':
                        commentaire+='Raison : Comportement antisportif.'
                    break
                    case 'dangerousPlay':
                        commentaire+='Raison : Jeu dangereux.'
                    break
                }
            }

            this.text = commentaire
        }
    }
}